'use client'

import LoanComparatorQuotationForm from './LoanComparatorQuotationForm'

interface LoanComparatorQuotationFormPageProps {
    initialStep?: number
}

export default function LoanComparatorQuotationFormPage({ initialStep = 1 }: LoanComparatorQuotationFormPageProps) {
    return (
        <div className="max-w-[1170px] mx-auto px-[15px] pt-[10px] pb-0 md:pt-[30px] md:pb-[60px]">
            <LoanComparatorQuotationForm initialStep={initialStep} />
        </div>
    )
}
